import { useNavigate, useParams } from 'react-router-dom';
import ProjectInfo from './ProjectInfo';
import { Box } from '@mui/material';
import useFetch from '../../api/useFetch';
import Header from '../../components/special/Header';
import { useAiPageContext } from '../../components/ai-chat';
import { ExoAiOriginChip } from '../../components/exo/ExoAiOriginChip';

export const ShowProject = () => {
  const { id } = useParams();
  const { apiData, setApiData } = useFetch(`projects/${id}/statistics`);

  useAiPageContext(
    apiData?.data && { type: 'project', id: Number(id), label: apiData.data.name },
  );

  const navigate = useNavigate();

  return (
    <Box className="flex flex-col h-full">
      <Header
        title={
          apiData && (
            <>
              <ExoAiOriginChip record={apiData.data} />
              {apiData.data.name}
            </>
          )
        }
      />
      <ProjectInfo
        selectedProject={apiData}
        onDelete={() => navigate('/projects')}
        onChange={setApiData}
      />
    </Box>
  );
};
